import { once } from "events";
import * as PROJECT_CODE from "../../constants/projectCode";
import firebase from "../../lib/firebase.prod";

const firebaseRef = firebase.database();

export default async function saveCoolingPeriodExtension(
  clientId,
  coolingPeriodExtensionDay
) {
  firebaseRef
    .ref("/kavtek_clients/" + PROJECT_CODE.projectCode + "/salesAgents/")
    .once("value", (snapshot) => {
      let salesAgents = snapshot.val();
      for (let i = 0; i < salesAgents.length; i++) {
        let clientsForThisSalesAgent = salesAgents[i]?.myClients;
        if (clientsForThisSalesAgent) {
          let clientsKeysArr = Object.keys(clientsForThisSalesAgent);
          if (clientsKeysArr.includes(clientId)) {
            firebaseRef
              .ref(
                "/kavtek_clients/" +
                  PROJECT_CODE.projectCode +
                  "/salesAgents/" +
                  i +
                  "/myClients/" +
                  clientId +
                  "/documentInformation/document"
              )
              .update({
                coolingPeriodExtensionDay: parseInt(coolingPeriodExtensionDay),
              });
            break;
          }
        }
      }
    });
}
